<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { OperationFinancialInstrumentEnum } from '@app/models/api/enums/OperationFinancialInstrumentEnum';
	import SharesHeader from './SharesHeader.svelte';
	import BondsHeader from './BondsHeader.svelte';
	import TPHeader from './TPHeader.svelte';

	export let operation: OperationModel;

	let headerComponent: typeof SharesHeader | typeof BondsHeader | typeof TPHeader;

	switch (operation.financialInstrument) {
		case OperationFinancialInstrumentEnum.STOCKS:
			headerComponent = SharesHeader;
			break;
		case OperationFinancialInstrumentEnum.BONDS:
			headerComponent = BondsHeader;
			break;
		case OperationFinancialInstrumentEnum.EQUITY_SECURITIES:
			headerComponent = TPHeader;
			break;
		case OperationFinancialInstrumentEnum.DONATIONS:
			break;
	}
</script>

<svelte:component this={headerComponent} {operation} />
